import { App as AntdApp, ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { useEffect, useRef } from 'react';
import { RouterProvider } from 'react-router-dom';
import { useUserStore } from '@/store/userStore';
import { setUmengUser } from '@/utils/umeng';
import { router } from './router';
import { themeConfig } from './theme';
// for date-picker i18n
import 'dayjs/locale/zh-cn';

function AuthBootstrap() {
  const hasHydrated = useUserStore((state) => state.hasHydrated);
  const refreshUserInfo = useUserStore((state) => state.refreshUserInfo);
  const hasBootstrappedRef = useRef(false);

  useEffect(() => {
    if (!hasHydrated || hasBootstrappedRef.current) {
      return;
    }

    hasBootstrappedRef.current = true;

    const user = useUserStore.getState().user;
    if (!user) {
      return;
    }

    let disposed = false;

    const bootstrapAuth = async () => {
      try {
        await refreshUserInfo();
      } catch (error) {
        if (!disposed) {
          console.error('Bootstrap my_info error:', error);
        }
      }
    };

    void bootstrapAuth();

    return () => {
      disposed = true;
    };
  }, [hasHydrated, refreshUserInfo]);

  return null;
}

function UmengUserBinding() {
  const user = useUserStore((state) => state.user);

  useEffect(() => {
    setUmengUser(user?.id ? String(user.id) : user?.phone);
  }, [user?.id, user?.phone]);

  return null;
}

function App() {
  return (
    <ConfigProvider
      theme={themeConfig}
      locale={zhCN}
    >
      <AntdApp>
        <AuthBootstrap />
        <UmengUserBinding />
        <RouterProvider router={router} />
      </AntdApp>
    </ConfigProvider>
  );
}

export default App;
